import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const MilestoneConnectorBar = (props) => {
  return (
    <div
    style={{
      backgroundColor: '#fff',
      borderRadius: '5px',
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.2)',
    }}
    className="slds-p-vertical_x-small"
    >
      <ul className="milestone-progress-bar slds-grid" style={{ paddingLeft: '15%', paddingRight: '15%'}}>
        {Object.keys(props.trigger).length > 0 ? (
          <li className="slds-size_1-of-4">
            <span
              title="trigger"
              className={props.preMilestone !== 'trigger' ? 'completed' : ''}
              onClick={props.onMilestoneConnectorClicked}
              data-clickable={true}
            >
              Trigger/Guide
            </span>
          </li>
        ) : (
          <li className="slds-size_1-of-4">
            <div
              title="trigger"
              className={
                props.preMilestone === 'trigger'
                  ? 'active-empty-milestone'
                  : 'empty-milestone'
              }
              onClick={props.onMilestoneConnectorClicked}
              data-milestone="trigger"
              data-clickable={false}
            >
              Trigger/Guide
            </div>
          </li>
        )}
        {Object.keys(props.guide).length > 0 ? (
          <li className="slds-size_1-of-4">
            <span
              title="guide"
              className={props.preMilestone !== 'guide' ? 'completed' : ''}
              onClick={props.onMilestoneConnectorClicked}
              data-milestone="guide"
              data-clickable={true}
            >
              Guide/Key
            </span>
          </li>
        ) : (
          <li className="slds-size_1-of-4">
            <div
              title="guide"
              className={
                props.preMilestone === 'guide'
                  ? 'active-empty-milestone'
                  : 'empty-milestone'
              }
              onClick={props.onMilestoneConnectorClicked}
              data-milestone="guide"
              data-clickable={false}
            >
              Guide/Key
            </div>
          </li>
        )}
        {Object.keys(props.keyVar).length > 0 ? (
          <li className="slds-size_1-of-4">
            <span
              title="key"
              className={props.preMilestone !== 'key' ? 'completed' : ''}
              onClick={props.onMilestoneConnectorClicked}
              data-milestone="key"
              data-clickable={true}
            >
              Key/Crisis
            </span>
          </li>
        ) : (
          <li className="slds-size_1-of-4">
            <div
              title="key"
              className={
                props.preMilestone === 'key'
                  ? 'active-empty-milestone'
                  : 'empty-milestone'
              }
              onClick={props.onMilestoneConnectorClicked}
              data-milestone="key"
              data-clickable={false}
            >
              Key/Crisis
            </div>
          </li>
        )}
        {Object.keys(props.crisis).length > 0 ? (
          <li className="slds-size_1-of-4">
            <span
              title="crisis"
              className={props.preMilestone !== 'crisis' ? 'completed' : ''}
              onClick={props.onMilestoneConnectorClicked}
              data-milestone="crisis"
              data-clickable={true}
            >
              Crisis/Triumph
            </span>
          </li>
        ) : (
          <li className="slds-size_1-of-4">
            <div
              title="crisis"
              className={
                props.preMilestone === 'crisis'
                  ? 'active-empty-milestone'
                  : 'empty-milestone'
              }
              onClick={props.onMilestoneConnectorClicked}
              data-milestone="crisis"
              data-clickable={false}
            >
              Crisis/Triumph
            </div>
          </li>
        )}
      </ul>
    </div>
  );
};

MilestoneConnectorBar.propTypes = {
  onMilestoneConnectorClicked: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  trigger: state.milestoneConnectors.trigger,
  guide: state.milestoneConnectors.guide,
  keyVar: state.milestoneConnectors.keyVar,
  crisis: state.milestoneConnectors.crisis,
});

export default connect(mapStateToProps, null)(MilestoneConnectorBar);
